<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="parentComponent.filterData()">

            <b-form-group :label="$t('search')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.search" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('ean')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.ean" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('sku')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.sku" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('category')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.category" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('space')" label-cols-sm="3">
                <MultiselectSpaces
                    :initial-value="parentComponent.filters.spaces"
                    :preserve-search="true"
                    :disabled="loading"
                    placeholder=""
                    @changeTrackBy="parentComponent.filters.spaces = $event"
                />
            </b-form-group>

            <div class="d-flex gap-3">
                <ButtonIcon :disabled="parentComponent.loading" @click="parentComponent.filterData()">
                    {{ $t('filter') }}
                </ButtonIcon>
                <ButtonIcon variant="light" :disabled="parentComponent.loading" @click="parentComponent.resetData()">
                    {{ $t('reset') }}
                </ButtonIcon>
            </div>

        </form>
    </Card>
</template>



<script>
    import MultiselectSpaces from '@/components/common/MultiselectSpaces.vue';

    export default {
        name: 'Filters',
        components: { MultiselectSpaces },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
        },
    };
</script>
